import { ENV } from "../Utils";

async function doFetch(url, params = {}) {
  const res = await fetch(url, params);
  const ct = res.headers.get("content-type") || "";
  const parse = ct.includes("application/json")
    ? () => res.json()
    : () => res.text();
  const data = await parse().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(data?.message || `Request error ${res.status}`);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
}

const authHeaders = (accessToken) =>
  accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

export const institutionDashboardApi = {
  /**
   * Obtiene el resumen del dashboard para una institución específica.
   * @param {string} accessToken
   * @param {string} institutionId - ID de la Institución (Profile)
   */
  getOverview: (accessToken, institutionId) =>
    doFetch(`${ENV.BASE_API}/dashboard/institution/${institutionId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        ...authHeaders(accessToken),
      },
    }),
};
